import { useEffect, useState } from "react";
import { fetchSeasonPassState } from "../lib/api";

let cachedPromise = null;

/**
 * useSeasonPassFlag — shared singleton state for the admin-toggled Season
 * Pass feature flag. Components anywhere in the app can call this hook to
 * gate Season-Pass-specific UI surfaces (banners, tabs, claim buttons…).
 *
 * Returns: { enabled, label, ends_at, loading }
 * When `enabled === false`, all Wave D Season Pass UI must render nothing.
 */
export function useSeasonPassFlag() {
  const [state, setState] = useState({ enabled: false, label: "", ends_at: null, loading: true });

  useEffect(() => {
    if (!cachedPromise) {
      cachedPromise = fetchSeasonPassState().catch(() => ({ enabled: false }));
    }
    cachedPromise.then((s) => {
      setState({ ...s, loading: false });
    });
  }, []);

  return state;
}

// Manual refresh hook — admin uses this after toggling so the banner
// updates without a hard reload.
export function refreshSeasonPassFlag() {
  cachedPromise = fetchSeasonPassState().catch(() => ({ enabled: false }));
  return cachedPromise;
}
